import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';

const CustomButton = ({
    onClick,
    loading = false,
    label = "",
    color = "#ffffff",
    bgcolor = "#1976d2",
    hoverColor = null,
    startIcon = null,
    disabled = false,
    variant = "contained",
    width = null,
}) => {
    return (
        <Button
            onClick={onClick}
            startIcon={startIcon}
            disabled={disabled}
            sx={{
                width: width,
                backgroundColor: bgcolor,
                color: color,
                borderRadius: '8px',
                px: 3,
                py: 0.6,
                textTransform: 'none',
                fontWeight: 500,
                boxShadow: 'none',
                transition: 'all 0.2s ease',

                // ✅ CONTAINED
                ...(variant === 'contained' && {
                    backgroundColor: bgcolor,
                    color: color,

                    '&:hover': {
                        filter: 'brightness(0.85)',
                    },
                }),

                // ✅ OUTLINED
                ...(variant === 'outlined' && {
                    backgroundColor: "#ffffff",
                    borderColor: bgcolor,
                    color: bgcolor,
                    border: 1.8,

                    '&:hover': {
                        backgroundColor: alpha(hoverColor || color, 0.15),
                        borderColor: hoverColor,
                        color: hoverColor,
                    },
                }),

                // ✅ BORDERLESS
                ...(variant === 'borderless' && {
                    backgroundColor: 'transparent',
                    color: bgcolor,

                    border: '1.8px solid transparent',

                    '&:hover': {
                        backgroundColor: alpha(hoverColor || color, 0.12),
                        borderColor: hoverColor || color,
                        color: hoverColor || color,
                    },
                }),

                '&:active': {
                    transform: 'scale(0.98)', // click effect
                },

                '&:disabled': {
                    backgroundColor: '#e0e0e0', // soft gray
                    color: '#9e9e9e',           // muted text
                    boxShadow: 'none',
                }
            }}
        >
            {loading ? `${label}...` : label}
        </Button>
    );
}

export default CustomButton;